(() => {
  function init(scope) {
    scope.querySelectorAll('[data-review-carousel]').forEach(carousel => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('.photo-reviews__track');
      const slides = Array.from(track.children);
      const dots = Array.from(carousel.querySelectorAll('[data-review-dot]'));
      const controls = carousel.querySelector('.photo-reviews__controls');
      if (!controls) return;
      let current = 0;
      let frame;
      const status = carousel.querySelector('[data-review-status]');
      slides.forEach((slide, i) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', `${i + 1} of ${slides.length}`);
      });
      const update = () => {
        const edge = track.getBoundingClientRect().left;
        let distance = Infinity;
        slides.forEach((slide, i) => {
          const d = Math.abs(slide.getBoundingClientRect().left - edge);
          if (d < distance) { distance = d; current = i; }
        });
        dots.forEach((dot, i) => {
          if (i === current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        status.textContent = `Review ${current + 1} of ${slides.length}`;
      };
      const go = index => {
        const target = (index + slides.length) % slides.length;
        const offset = slides[target].getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollTo({left: track.scrollLeft + offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      carousel.querySelector('[data-review-prev]').addEventListener('click', () => go(current - 1));
      carousel.querySelector('[data-review-next]').addEventListener('click', () => go(current + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
      });
      track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, {passive:true});
      controls.hidden = false;
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
